import { green, red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#112F82',
    },
    secondary: {
      main: '#06102B',
    },
    error: {
      main: red.A400,
    },
    highConfidence: {
      main: green.A400,
    },
    mediumConfidence: {
      main: '#FF9040',
    },
  },
  typography: {
    fontFamily: 'IBM Plex Sans',
  },
});

export default theme;
